import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import { type EmberChangeset } from 'ember-changeset';
import t from 'ember-intl/helpers/t';
import type { WrFormComponentSignature } from 'ember-wiser/components/form';
import Dropdown from './dropdown';

interface S {
  changeset: EmberChangeset;
  form: WrFormComponentSignature<
    EmberChangeset,
    unknown
  >['Blocks']['default'][0];
  prefix: (property: string) => string;
}

const stoppingReasons = [
  'noResponse',
  'lostResponse',
  'allergy',
  'immunogenicity',
  'remission',
  'pregnancy',
  'infection',
  'cancer',
  'surgery',
  'patientChoiceSucces',
  'patientChoiceFailure'
] as const;

export default <template>
  <div class='mb-4 flex gap-2'>
    <@form.Input type='date' @name={{@prefix 'endDate'}} />
    <Dropdown
      @changeset={{@changeset}}
      @placeholder="Motif d'arrêt"
      @propertyName={{@prefix 'stoppingReason'}}
      as |dropdown|
    >
      {{#each stoppingReasons as |reason|}}
        <dropdown.Item
          @key={{reason}}
          @value={{t (concat 'medications.stopping-reason.' reason)}}
        />
      {{/each}}
    </Dropdown>
  </div>
  <@form.Textarea
    rows='2'
    @name={{@prefix 'stoppingComment'}}
    placeholder='Commentaire'
  />
</template> satisfies TOC<S>;
